export default __webpack_public_path__ + "static/decor-56f528f53f072ffd8b11d16817bdd5c9.svg";